<div class="flex flex-col gap-5">

    <div class="grid gap-3 sm:grid-cols-2" role="radiogroup" aria-label="Reporting type">

        <button type="button" role="radio" [attr.aria-checked]="createScreeningService.reportType() === 'standard'"
            (click)="select('standard')"
            class="relative flex flex-col rounded-xl border-[1.5px] p-5 text-left transition-all"
            [class]="createScreeningService.reportType() === 'standard' ? 'border-brand-studio bg-brand-studio/10 ring-2 ring-brand-studio/25' : 'border-border bg-card hover:border-foreground/30 hover:shadow-sm'">
            <span class="absolute right-3.5 top-3.5 grid size-5 place-items-center rounded-full border-[1.5px]"
                [class]="createScreeningService.reportType() === 'standard' ? 'border-brand-studio bg-brand-studio text-white' : 'border-border bg-card text-transparent'"
                aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
            </span>
            <span class="flex items-center gap-3">
                <span class="grid size-10 shrink-0 place-items-center rounded-md transition-colors"
                    [class]="createScreeningService.reportType() === 'standard' ? 'bg-brand-studio text-white' : 'bg-muted text-muted-foreground'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                        <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                        <path d="M10 9H8" />
                        <path d="M16 13H8" />
                        <path d="M16 17H8" />
                    </svg>
                </span>
                <span>
                    <span class="block font-heading text-[17px] font-bold leading-tight text-foreground">Standard
                        report</span>
                    <span class="mt-1 block text-[11px] font-bold uppercase tracking-wider"
                        [class]="createScreeningService.reportType() === 'standard' ? 'text-brand-studio-dark dark:text-brand-studio' : 'text-muted-foreground'">No
                        setup needed</span>
                </span>
            </span>
            <span class="mt-3 block text-[13px] leading-relaxed text-foreground/80">
                The default SHOUT screening report. Every creator scored against your requirements and red flags, with
                the evidence attached.
            </span>
        </button>

        <button type="button" role="radio" [attr.aria-checked]="createScreeningService.reportType() === 'custom'"
            (click)="select('custom')"
            class="relative flex flex-col rounded-xl border-[1.5px] p-5 text-left transition-all"
            [class]="createScreeningService.reportType() === 'custom' ? 'border-brand-studio bg-brand-studio/10 ring-2 ring-brand-studio/25' : 'border-border bg-card hover:border-foreground/30 hover:shadow-sm'">
            <span class="absolute right-3.5 top-3.5 grid size-5 place-items-center rounded-full border-[1.5px]"
                [class]="createScreeningService.reportType() === 'custom' ? 'border-brand-studio bg-brand-studio text-white' : 'border-border bg-card text-transparent'"
                aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
            </span>
            <span class="flex items-center gap-3">
                <span class="grid size-10 shrink-0 place-items-center rounded-md transition-colors"
                    [class]="createScreeningService.reportType() === 'custom' ? 'bg-brand-studio text-white' : 'bg-muted text-muted-foreground'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        <path d="m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72" />
                        <path d="m14 7 3 3" />
                        <path d="M5 6v4" />
                        <path d="M19 14v4" />
                        <path d="M10 2v2" />
                        <path d="M7 8H3" />
                        <path d="M21 16h-4" />
                        <path d="M11 3H9" />
                    </svg>
                </span>
                <span>
                    <span class="block font-heading text-[17px] font-bold leading-tight text-foreground">Custom
                        analysis</span>
                    <span class="mt-1 block text-[11px] font-bold uppercase tracking-wider"
                        [class]="createScreeningService.reportType() === 'custom' ? 'text-brand-studio-dark dark:text-brand-studio' : 'text-muted-foreground'">You
                        write the spec</span>
                </span>
            </span>
            <span class="mt-3 block text-[13px] leading-relaxed text-foreground/80">
                Describe the report you actually want. Tell us how to cut, rank and present the results and we'll build
                the report around it.
            </span>
        </button>
    </div>

    @switch (createScreeningService.reportType()) {

    @case ('standard') {
    <div class="flex flex-col gap-3.5">
        <div class="rounded-xl border border-border bg-muted p-4">
            <h3 class="mb-3 flex items-center gap-2 font-heading text-sm font-bold text-foreground">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text-brand-studio-dark dark:text-brand-studio" aria-hidden="true">
                    <path d="m3 17 2 2 4-4" />
                    <path d="m3 7 2 2 4-4" />
                    <path d="M13 6h8" />
                    <path d="M13 12h8" />
                    <path d="M13 18h8" />
                </svg>
                What's in the standard report
            </h3>
            <ul class="m-0 grid list-none gap-2.5 p-0 sm:grid-cols-2">
                @for (item of standardIncludes; track item) {
                <li class="flex gap-2.5 text-[13px] leading-relaxed text-foreground/80">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                        class="mt-0.5 shrink-0 text-brand-studio-dark dark:text-brand-studio" aria-hidden="true">
                        <path d="M20 6 9 17l-5-5" />
                    </svg>
                    {{ item }}
                </li>
                }
            </ul>
        </div>
        <p
            class="m-0 inline-flex items-center gap-2.5 self-start rounded-full bg-brand-studio/10 px-3.5 py-2.5 text-[13px] font-semibold text-brand-studio-dark dark:text-brand-studio">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                aria-hidden="true">
                <path d="M20 6 9 17l-5-5" />
            </svg>
            Nothing else to set — continue to the review.
        </p>
    </div>
    }

    @case ('custom') {
    <bb-field label="How should we report the results?" [required]="true"
        hint="Write it as if you were briefing an analyst. The standard scoring still runs underneath — this shapes how it's presented back to you.">
        <div class="flex flex-col">
            <textarea rows="7" [value]="createScreeningService.reportPrompt()"
                (input)="setPrompt($any($event.target).value)"
                placeholder="Describe exactly what you want to see in the screening report — how results should be grouped, ranked, summarised and delivered…"
                class="w-full resize-y rounded-md border border-border bg-card px-3.5 py-2.5 text-base outline-none focus:border-brand-studio focus:ring-2 focus:ring-brand-studio/25 placeholder:text-muted-foreground"></textarea>
            <p class="mt-1.5 text-right text-[11px] text-muted-foreground" aria-hidden="true">
                {{ promptCount() }} characters
            </p>
        </div>

        <p class="mb-2 mt-2.5 text-[11px] text-muted-foreground">Or start from one of these:</p>
        <div class="flex flex-wrap gap-2">
            @for (example of promptExamples; track example) {
            <button type="button" (click)="appendExample(example)"
                class="inline-flex items-center gap-1.5 rounded-full border border-border bg-muted px-3 py-1.5 text-[12.5px] font-medium text-foreground/80 transition-colors hover:border-brand-studio hover:bg-brand-studio/10 hover:text-brand-studio-dark dark:hover:text-brand-studio">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    aria-hidden="true">
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                </svg>
                {{ example }}
            </button>
            }
        </div>
    </bb-field>
    }

    }
</div>
